import { createSelector } from '@reduxjs/toolkit';

const viewedHotels = (state) => state.get('viewedHotels');
const getIsViewed = (state, id) => state.get('viewedHotels').contains(id);

// eslint-disable-next-line
export const makeGetIsViewed = () => createSelector(getIsViewed, (id) => id);

export const viewedHotelsSelector = createSelector(
  viewedHotels,
  (hotels) => hotels?.toJS() || [],
);
